import React from 'react'
import { GA_PAGES } from '../../api/gaHelper'
import { page } from '../../hocs/page'
import { Error404 } from '../../components'

export default page(() => { return <Error404 /> }, {pageView: GA_PAGES.ERROR404, uiNavigationRoute: null})
